import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Legend } from "recharts";
import { useApi } from "../../lib/api";
import { Card, Loading } from "../kit";
import { rupiah } from "../../lib/constants";

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "Mei", "Jun", "Jul", "Agu", "Sep", "Okt", "Nov", "Des"];
const label = (k) => `${MONTHS[Number(k.slice(5)) - 1]} ${k.slice(2, 4)}`;
function short(v) {
  if (v >= 1e6) return `${(v / 1e6).toFixed(v % 1e6 ? 1 : 0)} jt`;
  if (v >= 1e3) return `${Math.round(v / 1e3)} rb`;
  return v;
}

const MARGIN = { top: 4, right: 8, left: 0, bottom: 0 };
const X_TICK = { fontSize: 12, fontWeight: 600 };
const Y_TICK = { fontSize: 11 };
const CURSOR = { fill: "#F1F5F9" };
const TOOLTIP_STYLE = { borderRadius: 12, fontSize: 13 };
const LEGEND_STYLE = { fontSize: 13, fontWeight: 600 };
const BAR_RADIUS = [6, 6, 0, 0];
const tooltipFmt = (v, n) => [rupiah(v), n];

export function MonthlyChart() {
  const { data } = useApi("/finance/monthly?months=6", 30000);
  if (!data) return <Loading />;
  const rows = data.map((d) => ({ ...d, name: label(d.month) }));
  return (
    <Card data-testid="fin-monthly-chart">
      <h3 className="font-bold text-lg mb-3">Pemasukan vs Pengeluaran (6 bulan)</h3>
      <div className="h-64">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={rows} margin={MARGIN} barGap={4}>
            <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#E2E8F0" />
            <XAxis dataKey="name" tick={X_TICK} axisLine={false} tickLine={false} />
            <YAxis tickFormatter={short} tick={Y_TICK} axisLine={false} tickLine={false} width={48} />
            <Tooltip formatter={tooltipFmt} cursor={CURSOR} contentStyle={TOOLTIP_STYLE} />
            <Legend iconType="circle" wrapperStyle={LEGEND_STYLE} />
            <Bar dataKey="income" name="Pemasukan" fill="#10B981" radius={BAR_RADIUS} />
            <Bar dataKey="expense" name="Pengeluaran" fill="#F43F5E" radius={BAR_RADIUS} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </Card>
  );
}
